
import { defineComponent } from 'vue'
import NoteList from '@/components/ja/note/NoteList.vue'
import ProgramList from '@/components/ja/note/ProgramList.vue'

export default defineComponent({
  name: 'NoteJa',
  components: {
    NoteList,
    ProgramList
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'note'
    }
  }
})
